import React from "react";

import { ActionDropdown, Div, IconButton, Span, Tag } from "@driftt/tide-core";
import { Icon } from "@driftt/tide-icons";

import { ATTRIBUTE_STATUS } from "../constants";

import "./style.css";

const getUserPropertyByName = (user = {}, propertyName = "") => {
  if (!user.attributes) {
    return "";
  }

  // User properties directly on the user object cannot be objects and can only be primitives
  const isValidUserProperty = typeof user[propertyName] !== "object";

  if (user[propertyName] && isValidUserProperty) {
    return user[propertyName];
  }

  return user.attributes[propertyName];
};

const IsSelectedCell = (property) => {
  return property.isSelected ? <Icon name="check" height="12px" /> : <Div />;
};

const PreviewCell = (preview) => {
  return <Span className="property-preview-cell">{preview}</Span>;
};

const SourceCell = ({ source }) => {
  switch (true) {
    case source.includes("CLEARBIT"):
      return <Span>{`Clearbit`}</Span>;
    case source.includes("demandbase"):
      return <Span>{`Demandbase`}</Span>;
    case source.includes("SALESFORCE_ACCOUNT"):
      return <Span>{"Salesforce Account"}</Span>;
    case source.includes("SALESFORCE_LEAD"):
      return <Span>{"Salesforce Lead"}</Span>;
    case source.includes("SALESFORCE"):
      return <Span>{`Salesforce Contact`}</Span>;
    case source.includes("marketo"):
      return <Span>{`Marketo`}</Span>;
    case source.includes("hubspot"):
      return <Span>{`Hubspot`}</Span>;
    default:
      return <Span>{`-`}</Span>;
  }
};

const NameCell = ({ displayName }) => (
  <Div className="contacts--properties-table--name">{displayName}</Div>
);

const TypeCell = ({ type }) => <Tag text={type} />;

const SourcedTypeCell = ({ propertyDefinitionType }) => (
  <Tag text={propertyDefinitionType} />
);

const ActionsCell = (property, index, onSelect, onArchive, attributeType) => {
  let actions = [];

  if (attributeType !== "archived") {
    actions.push({
      label: `${property.isSelected ? "Hide" : "Show"} in conversation`,
      action: (hideDropdown) => {
        hideDropdown();
        onSelect(property, index);
      },
    });
  }

  if (attributeType === "custom" || attributeType === "archived") {
    actions.push({
      label: `${
        attributeType === "custom" ? "Archive" : "Unarchive"
      } attribute`,
      action: (hideDropdown) => {
        hideDropdown();
        onArchive(
          property,
          attributeType === "custom"
            ? ATTRIBUTE_STATUS.ARCHIVED
            : ATTRIBUTE_STATUS.ENABLED
        );
      },
    });
  }

  return (
    <ActionDropdown
      className="contact-attribute-row-action"
      trigger={<IconButton icon="meatballs" />}
      tethered={true}
      align="right"
      actions={actions}
    />
  );
};

export const RowFormatter = (
  property,
  index,
  user,
  onSelect,
  nameFilter = "",
  onArchive,
  attributeType
) => {
  //debugger;
  if (
    nameFilter === "" ||
    property.displayName.toLowerCase().startsWith(nameFilter.toLowerCase())
  ) {
    return {
      data: [
        { content: NameCell(property) },
        { content: TypeCell(property) },
        { content: PreviewCell(getUserPropertyByName(user, property?.name)) },
        { content: IsSelectedCell(property) },
        {
          content: ActionsCell(
            property,
            index,
            onSelect,
            onArchive,
            attributeType
          ),
        },
      ],
    };
  }

  return { data: [] };
};

export const SourcedRowFormatter = (
  property,
  index,
  onSelect,
  nameFilter = "",
  disableAll,
  onArchive
) => {
  if (
    nameFilter === "" ||
    property.displayName.toLowerCase().startsWith(nameFilter.toLowerCase())
  ) {
    return {
      data: [
        { content: NameCell(property) },
        { content: SourceCell(property) },
        { content: SourcedTypeCell(property) },
        { content: IsSelectedCell(property) },
        {
          content: ActionsCell(
            property,
            index,
            onSelect,
            disableAll,
            onArchive
          ),
        },
      ],
    };
  }

  return { data: [] };
};
